module.exports = "../../static/img/logo.08e947b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = 1082
// module chunks = 0